/* eslint-disable max-len -- ignored for long regex patterns */

export const EmailRegex: RegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const PhoneRegex: RegExp = /^((?:(([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})([0-9]{4})|([0-1][0-9][0-9])(\d{7})|([6789]\d{9}))(#\w+)?$/;
export const ProdPhoneRegex: RegExp = /^((?:(([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})([0-9]{4})|([6789]\d{9}))(#\w+)?$/;
export const PostalCodeRegex: RegExp = /^\d{5}(-\d{4})?$/;

/**
 * @pattern ^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z-0-9]+\.)+[a-zA-Z]{2,}))$ Please enter a valid email address
 * @example "user@domain.com"
 */
export type Email = string;


//^((?:(([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})([0-9]{4})|([0-1][0-9][0-9])(\d{7}))(#\w+)?$
//Adding temp check to allow IND numbers for testing purchase - 2023-08-31
/**
 * @pattern ^((?:(([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})([0-9]{4})|([0-1][0-9][0-9])(\d{7})|([6789]\d{9}))(#\w+)?$ Please enter a valid phone number
 * @example "3305143662"
 */
export type Phone = string;

/**
 * @pattern \d{5}
 * @example "10002"
 */
export type PostalCode = string;

/**
 * @pattern \S+ Value must not be an empty string or contain only spaces
 */
export type NonEmptyString = string;

/**
 * @maxLength 50
 * @pattern \S+ Value must not be an empty string or contain only spaces
 */
export type NonEmptyString50 = string;

/**
 * @maxLength 75
 * @pattern \S+ Value must not be an empty string or contain only spaces
 */
export type NonEmptyString75 = string;

/**
 * @maxLength 100
 * @pattern \S+ Value must not be an empty string or contain only spaces
 */
export type NonEmptyString100 = string;

/**
 * @maxLength 250
 * @pattern \S+ Value must not be an empty string or contain only spaces
 */
export type NonEmptyString250 = string;

/**
 * @maxLength 500
 * @pattern \S+ Value must not be an empty string or contain only spaces
 */
export type NonEmptyString500 = string;

/**
 * @maxLength 500
 */
export type String500 = string;

/**
 * @maxLength 1000
 * @pattern \S+ Value must not be an empty string or contain only spaces
 */
export type NonEmptyString1000 = string;

/**
 * @maxLength 1200
 * @pattern \S+ Value must not be an empty string or contain only spaces
 */
export type NonEmptyString1200 = string;

export const validateEmail = (email: Email | undefined | null): boolean => {
  if (!email) {
    return false;
  }
  return EmailRegex.test(email);
};

export const isValidPhoneNumber = (
  phone: Phone | undefined | null,
  _/*isTestEnv*/: boolean,
): boolean => {
  if (!phone) {
    return false;
  }
  // TODO: Re-enable rejecting invalid phone numbers in prod
  // return isTestEnv ? PhoneRegex.test(phone) : ProdPhoneRegex.test(phone);
  return PhoneRegex.test(phone);
};

export const validatePostalCode = (postalCode: PostalCode | undefined | null): boolean => {
  if (!postalCode) {
    return false;
  }
  return PostalCodeRegex.test(postalCode);
};
